<template>
  <Modal class="discountTrialBg" class-name="t20" v-model="trialModal" @on-cancel="hide" :mask-closable="false" :footer-hide="true" width="578">
    <!--重写顶部-->
    <p slot="header" class="ivu-modal-header-content">贴现计算器</p>

    <div class="discountTrial">
      <div class="discountTrial-body">
        <Form ref="calculatorForm" :model="form" :rules="rules" hide-required-mark label-position="right" :label-width="130">
        <!-- <Form class="calculator-form" ref="calculatorForm" :model="form" hideRequiredMark :colon="false" :rules="rules" labelAlign="left"> -->
          <FormItem label="票面总金额：" prop="billAmount">
            <Input type="text" v-model="form.billAmount" placeholder="请填写票面总金额" v-text-only="{textType: 'double' }"></Input>
            <p class="positionrightcenter dp-c-primary">{{digitUppercase(form.billAmount)}}</p>
          </FormItem>
          <FormItem label="贴现日：" prop="issueDate">
            <DatePicker type="date" :open="issueDateOpen" :options="disabledStartDate" :value="form.issueDate" @on-change="handleIssueDateChange">
              <div class="form-DatePicker" :style="{ color: (form.issueDate ? '#657180' : '#C3CBD6') }"  @click="issueDateOpen = !issueDateOpen">
                {{form.issueDate || '请选择贴现日'}}
                <svg-icon class="f19 positionrightcenter" icon-class="Calendar"></svg-icon>
              </div>
            </DatePicker>
          </FormItem>
          <FormItem label="到期日：" prop="dueDate">
            <DatePicker type="date" :open="dueDateOpen" :options="disabledEndDate" :value="form.dueDate" @on-change="handleDueDateChange">
              <div class="form-DatePicker" :style="{ color: (form.dueDate ? '#657180' : '#C3CBD6') }"  @click="dueDateOpen = !dueDateOpen">
                {{form.dueDate || '请选择到期日'}}
                <svg-icon class="f19 positionrightcenter" icon-class="Calendar"></svg-icon>
                <p class="positionrightcenter dp-c-primary" style="right: 40px;" v-show="form.days">{{form.days}} + {{form.adjustDay}} 天</p>
                <div class="positionrightcenter date-tip">i <p>根据选择贴现日和到期日得出距离到期天数 {{form.days || 0}}天， <br> 遇法定节假日或周末顺延 {{form.adjustDay || 0}} 天</p></div>
              </div>
            </DatePicker>
          </FormItem>
          <FormItem label="贴现年化利率：" prop="price">
            <Input type="text" v-model="form.annualRate" placeholder="请输入年化利率" v-text-only="{textType: 'double' }"></Input>
            <p class="positionrightcenter">%</p>
          </FormItem>
        </Form>
      </div>

      <div class="discountTrial-footer">
        <div class="discountTrial-footer-content" v-if="realAmount">
          <p>计算结果：</p>
          <!-- <div>
            <p>每十万</p>
            <p>{{formatMoney(realProfit)}}</p>
          </div> -->
          <div>
            <p>贴现可得金额</p>
            <p>{{formatMoney(realAmount)}}</p>
          </div>
          <div>
            <p>支付利息</p>
            <p>{{formatMoney(realInterest)}}</p>
          </div>
        </div>
        <div>
          <Button type="primary" class="w100" :disabled="isDisabled" @click="onSubmit">{{btnName}}</Button>
          <Button type="default" class="w65 ml5" @click="clearForm">重置</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  data () {
    return {
      trialModal: false,

      dueDateOpen: false,
      issueDateOpen: false,
      // 设置不可选日期
      disabledStartDate: {
        disabledDate: (startValue) => {
          const endValue = this.form.dueDate;
          if (!startValue || !endValue) return false;
          return new Date(startValue).getTime() > new Date(endValue).getTime();
        }
      },
      disabledEndDate: {
        disabledDate: (endValue) => {
          const startValue = this.form.issueDate;
          if (!endValue || !startValue) return false;
          return new Date(startValue).getTime() > new Date(endValue).getTime();
        }
      },

      initData: {
        billAmount: '', // 票面总金额
        issueDate: '', // 贴现日
        dueDate: '', // 到期日
        days: '',
        adjustDay: '', // 调整日

        pricingType: 'ANNUAL_RATE', // 定价方式： PROFIT	每十万收益； ANNUAL_RATE	年化利率； ANNUAL_RATE_MONTH	月利率； 
        profit: '', // 每十万收益
        annualRate: '', // 年化利率
        annualRateMonth: '', // 月利率

        profitPlus: '', // 每十万+
        electricityCheckFee: '', // 电查费
        transferFee: '' // 划款费
      },
      form: {},
      rules: {
        billAmount: { required: true, message: '请输入票面金额', trigger: 'blur' },
        issueDate: { required: true, message: '请选择贴现日', trigger: 'change' },
        dueDate: { required: true, message: '请选择到期日', trigger: 'change' },
        price: {
          validator: (rule, value, callback) => {
            if (this.pricingType === 'PROFIT' && !Number(this.profit)) {
              callback(new Error('请输入每十万收益'))
            }
            if (this.pricingType === 'ANNUAL_RATE' && !Number(this.annualRate)) {
              callback(new Error('请输入年化利率'))
            }
            if (this.pricingType === 'ANNUAL_RATE_MONTH' && !Number(this.annualRateMonth)) {
              callback(new Error('请输入月利率'))
            }
            callback()
          },
          trigger: 'blur'
        }
      },

      realAmount: '',
      realProfit: '',
      realInterest: '',
      btnName: '立即计算'
    }
  },
  computed: {
    isDisabled () {
      if (this.form.billAmount && this.form.issueDate && this.form.dueDate) {
        if (this.form.pricingType === 'ANNUAL_RATE_MONTH' && this.form.annualRateMonth) {
          return false
        }
        if (this.form.pricingType === 'ANNUAL_RATE' && this.form.annualRate) {
          return false
        }
        if (this.form.pricingType === 'PROFIT' && this.form.profit) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    show () {
      this.form = this.deepCopy(this.initData)
      this.trialModal = true
      this.handleIssueDateChange(new Date().pattern("yyyy-MM-dd"))
    },
    hide () {
      this.trialModal = false
    },
    // 自定义日期格式改变事件
    handleDueDateChange (date) {
      this.form.dueDate = date;
      this.dueDateOpen = false;
      this.getDays()

      this.sendPost({
        url: '/web/holidayManage/find',
        data: { holidayDate: new Date(this.form.dueDate).getTime() },
        loading: false
      }, res => {
        this.form.adjustDay = res.data.data.day
      })
    },
    handleIssueDateChange (date) {
      this.form.issueDate = date;
      this.issueDateOpen = false;
      this.getDays()
    },
    getDays () {
      if (this.form.dueDate && this.form.issueDate) {
        let startTime = new Date(new Date(this.form.issueDate).setHours(0,0,0,0)).getTime()
        let endTime = new Date(new Date(this.form.dueDate).setHours(0,0,0,0)).getTime()
        this.form.days = (endTime - startTime)/1000/60/60/24
      }
    },

    // 清空
    clearForm () {
      this.$refs.calculatorForm.resetFields();
      this.form = this.deepCopy(this.initData);
      this.realAmount = ''
      this.realProfit = ''
      this.realInterest = ''
      this.btnName = '立即计算'
      this.handleIssueDateChange(new Date().pattern("yyyy-MM-dd"))
    },
    // 立即计算
    onSubmit () {
      this.$refs.calculatorForm.validate(valid => {
        if (valid) {
          console.log('submit!');
          this.handlePrice()
          this.btnName = '重新计算'
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 计算
    handlePrice () {
      const amount = Number(this.form.billAmount)

      // 到期天数 = 到期日-贴现日 + 调整日
      const diffDay = parseInt((new Date(this.form.dueDate).getTime() - new Date(this.form.issueDate).getTime()) / 24 / 60 / 60 / 1000)
      const dueDays = diffDay + this.form.adjustDay

      // 其他费用： 每十万加的利息 + 电查费 + 划款费
      const otherMoney = (amount * Number(this.form.profitPlus) / 100000) + Number(this.form.electricityCheckFee) + Number(this.form.transferFee)

      switch (this.form.pricingType) {
        case "ANNUAL_RATE_MONTH": // 月利率
          // 利息金额 = 票面金额 × 到期天数 × 利率 ÷ 30000 + 其他费用
          this.realInterest = amount * dueDays * Number(this.form.annualRateMonth) / 30000 + otherMoney
          break;
        case "ANNUAL_RATE": // 年化利率
          // 利息金额 = 票面金额 × 到期天数 × 利率 ÷ 36000 + 其他费用
          this.realInterest = amount * dueDays * Number(this.form.annualRate) / 36000 + otherMoney
          break;
        case "PROFIT": // 每十万收益
          // 利息金额 = 每十万收益 × 票面金额 ÷ 100000 + 其他费用
          this.realInterest = this.form.profit * amount / 100000 + otherMoney
          break;
      }

      // 成交金额 = 票面金额 - 利息金额
      this.realAmount = amount - this.realInterest

      // 每十万收益 = 利息金额 × 100000 ÷ 票面金额
      this.realProfit = this.realInterest * 100000 / amount
    }
  }
}
</script>


<style lang="less" scoped>
// 弹框组件
.discountTrialBg {
  /deep/ .ivu-modal-header {
    padding: 0;
    height: 80px;

    .ivu-modal-header-content {
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      background: url(~@/assets/img/common/icon_jsq.png) no-repeat 25px 9px,
        linear-gradient(90deg, #e12e32 0%, #e5322b 49%, #ff4800 100%);
      box-shadow: 0px 12px 11px 0px rgba(0, 0, 0, 0.1);
    }
  }

  /deep/ .ivu-modal-close {
    top: 2px;
    right: 3px;
  }

  /deep/ .ivu-modal-body {
    padding: 0;
  }

  .discountTrial {
    &-body {
      height: 270px;
      background: #fff;
      padding: 34px 84px 34px 73px;

      /deep/.ivu-date-picker, /deep/.ivu-date-picker-rel {
        width: 100%;
      }

      .form-DatePicker {
        display: inline-block;
        width: 100%;
        height: 32px;
        line-height: 1.5;
        padding: 4px 7px;
        border: 1px solid #d7dde4;
        border-radius: 4px;
        position: relative;
        text-align: left;
      }
      .positionrightcenter {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
      }
      .date-tip {
        width: 20px;
        height: 20px;
        border: 1px solid #d7dde4;
        border-radius: 50%;
        right: -30px;
        text-align: center;
        cursor: pointer;

        p {
          display: none;
          width: auto;
          height: auto;
          white-space: nowrap;
          text-align: left;
          padding: 5px 8px;
          border-radius: 4px;
          position: absolute;
          bottom: 27px;
          left: -6px;
          border: 1px solid #d7dde4;
          background: #fff;
          color: #333;

          &:after {
            display: block;
            width: 0;
            height: 0;
            content: '';
            border-top: 6px solid #fff;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            position: absolute;
            bottom: -6px;
            left: 8px;
          }
          &:before {
            display: block;
            width: 0;
            height: 0;
            content: '';
            border-top: 6px solid #d7dde4;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            position: absolute;
            bottom: -7px;
            left: 7px;
          }
        }
        &:hover p {
          display: block;
        }
      }
    }
    &-footer {
      height: 80px;
      background: #f6f4f5;
      box-shadow: 0px 12px 11px 0px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0px 20px 0px 50px;

      &-content {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          margin-left: 27px;
          text-align: left;

          p:nth-child(1) {
            font-size: 12px;
            color: #666666;
          }
          p:nth-child(2) {
            font-size: 16px;
            font-size: medium;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/CommonDiscountTrial.vue